// extracted by mini-css-extract-plugin
export default {"prevPath":"breadCrumbs_prevPath__G+7i4","space":"breadCrumbs_space__9+Kbz","currentPath":"breadCrumbs_currentPath__1bgw8"};